import 'react-app-polyfill/ie11';
import 'string.prototype.startswith';
import 'ie-array-find-polyfill';
import 'core-js/modules/es6.array.find-index';
import 'core-js/modules/es7.object.values';

import React from 'react';
import ReactDOM from 'react-dom';
import 'react-confirm-alert/src/react-confirm-alert.css';

import App from './components/App';
import configureStore from './store/configureStore';
import { provideRequestInterceptors, provideResponseInterceptors } from './utils/httpInterceptors';
import { setBaseUrl } from './utils/http';
import rollbarInit from './utils/rollbar';
import './utils/i18n';

setBaseUrl();
provideResponseInterceptors();
provideRequestInterceptors();

export const store = configureStore();
const MOUNT_NODE = document.getElementById('root');

if (process.env.NODE_ENV === 'production') {
    rollbarInit({
        token: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
        version: process.env.REACT_APP_VERSION,
        environment: window.location.host
    });

    window._version = {
        version: process.env.REACT_APP_VERSION,
    };
}

ReactDOM.render(<App store={store} />, MOUNT_NODE);
